/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as Yup from 'yup';
import DateInput from './DateInput';
import TimePicker from '../../../ui/TimePicker';
import { Icon } from '../../../ui/Icon';

import * as Styles from './index.styles';

const formSchema = Yup.object().shape({
  date: Yup.string().required('this is a mandatory field'),
  // time: Yup.string().required('this is a mandatory field'),
});

const SetDateTimeForm = props => {
  const {
    // values,
    touched,
    errors,
    handleChange,
    // handleBlur,
    handleSubmit,
    setFieldValue,
    SelectDateButtonText,
    TimeSelectorWatermark,
  } = props;
  return (
    <Form onSubmit={handleSubmit}>
      <DateInput {...props} />

      <div css={Styles.timeHolder}>
        <TimePicker
          className="timepicker"
          // css={styles.timePicker}
          onChange={value => {
            if (value) {
              setFieldValue('time', value.time + ' ' + value.meridiem);
            }
          }}
        />
        <span
          className="icon-holder"
          css={Styles.iconChevronHolder}
          aria-hidden="true"
        >
          <Icon name="chevron-down" />
        </span>
      </div>

      <ErrorMessage name="time" />
    </Form>
  );
};

class UserInfo extends React.Component {
  componentDidMount() {
    const { setValidationAction, submitForm } = this.props;
    if (setValidationAction) {
      setValidationAction(submitForm);
    }
  }

  render() {
    const { ...other } = this.props;
    return <SetDateTimeForm {...other} />;
  }
}

export default withFormik({
  mapPropsToValues: param => {
    return { date: param.date, time: param.time };
  },
  validationSchema: formSchema,
  handleSubmit: (values, param) => {
    const { setSubmitting, props } = param;
    if (props.onSaveStepData) {
      props.onSaveStepData(values);
    }
    setSubmitting(false);
  },

  displayName: 'SetDateTimeForm',
})(UserInfo);
